<template lang="pug">

  .groupTab(@click="click" :class="{ 'groupTab--active': active, 'groupTab--smaller': smaller }")
    v-progress-circular(v-if="loading" color="primary" indeterminate :size="smaller ? 16 : 25" :width="1")
    i(v-else aria-hidden="true" :class="{ [tabIcon]: true, 'tabIcon--smaller': smaller }").tabIcon.mdi
    span.tabTitle {{ `&nbsp;&nbsp;${tabTitle}` }}

</template>

<script>

  export default {
    name: 'GroupTab',

    props: {
      tabName: { type: String, required: true },
      tabTitle: { type: String, required: true },
      tabIcon: { type: String, required: true },
      active: { type: Boolean, default: () => false },
      loading: { type: Boolean, default: () => false },
      smaller: { type: Boolean, default: () => false },
    },

    methods: {
      click () {
        // this.$emit('click', this.tabName)
        this.$emit('click')
      },
    },
  }

</script>
